<template>
    <div class="famous-pedia-inform layout-sub-page">
        <!-- 1. 标题栏 -->
        <div class="title-bar dsp-flex">
            <div class="title-side title-gray">
                <span @click.passive="clickInformBack"><i class="iconfont icon-xiangzuo"></i></span>
            </div>
            <div class="title-middle">消息中心</div>
            <div class="title-side title-green title-green-read" v-bind:class="{'title-green-gray': totalUnreadNumber == 0}" @click.passive="clickInformReadAll">
                <span><i class="iconfont icon-read"></i>全部已读</span>
            </div>
        </div>
        <!-- 2. 通知列表 -->
        <inform-virtual-list
            v-bind:informList="totalInformList"
            v-bind:informData="totalInformData">
        </inform-virtual-list>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import InformVirtualList from '../../layouts/inform/InformVirtualList.vue'
import { FAMOUS_DOM } from '../../modules/dom'
export default {
    name: 'FamousPediaInform',
    components: { TitleBar, InformVirtualList },
    computed: {
        totalUnreadNumber() {
            return this.$store.state.inform.totalUnreadNumber;
        },
        totalInformList() {
            return this.$store.state.inform.totalInformList
        },
        totalInformData() {
            return this.$store.state.inform.totalInformData
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    created() {
        this.initData();
    },
    methods: {
        initDom() {
            this.$el.style.width = innerWidth + 'px';
            this.$el.style.height = innerHeight + 'px';
            this.$el.style.overflow = 'hidden';

            // listDom
            var listDom = document.getElementById('FamousInformList'),
                topDom = document.getElementsByClassName('title-bar')[0];
            if(topDom && listDom) {
                listDom.style.paddingTop = topDom.clientHeight + 'px';
                listDom.style.height = innerHeight + 'px';
            }

        },
        initData() {
            var gotInformListData = this.$store.state.inform.gotInformListData;
            if(!gotInformListData) {
                this.$router.replace('/famouspedia');
            }
        },
        clickInformBack() {
            this.$store.dispatch('inform/resetData');
            this.$router.replace('/famouspedia');
            FAMOUS_DOM.showFamousPediaPage();
        },
        clickInformReadAll() {
            this.$store.dispatch('inform/setAllMsgRead');
        }
    }
}
</script>